import React, { Component } from 'react'
import PropTypes from 'prop-types'
import autobind from 'autobind-decorator'
import TSelectForm from "../../common/TSelectForm";

const LightBoxOptions = [
	{ label: '맞춥니다.', value: 'fit' },
	{ label: '맞추지 않습니다.', value: '' }
]

class LightBoxForm extends Component {

	@autobind
	changeOptionInit(item) {
        const { onChange } = this.props
        onChange({
            setting: {
                lightBoxfitImagesInViewport: item.value
            },
            validated: false
        })
	}

	@autobind
	handleSelect(item) {
		const { onChange } = this.props
		onChange({
			setting: {
				lightBoxfitImagesInViewport: item.value
			},
			validated: true
		})
	}

	componentDidMount() {
		const { data } = this.props;
        const { lightBoxfitImagesInViewport } = data.setting
		if (typeof(data.setting.lightBoxfitImagesInViewport) === "undefined") {
			this.handleSelect(LightBoxOptions[0])
		}else{
            this.changeOptionInit({ value : lightBoxfitImagesInViewport});
		}
	}

	render() {
		const { plugin, data } = this.props;
		const { lightBoxfitImagesInViewport } = data.setting;
		return (
			<div className="desc_plugin10">
				<p className="txt_plugin" dangerouslySetInnerHTML={{ __html: plugin.rawDescription }} />

				<div className="info_plugin">
					<div className="item_set item_sub">
						이미지를 창 크기에
						<TSelectForm className="opt_set opt_plugin1" items={LightBoxOptions} selected={lightBoxfitImagesInViewport} onSelect={this.handleSelect} />
					</div>
				</div>
                {this.props.saveButton()}
			</div>
		)
	}
}

LightBoxForm.propTypes = {
	plugin: PropTypes.object.isRequired,
	data: PropTypes.object.isRequired,
	onChange: PropTypes.func.isRequired
}

export default LightBoxForm
